import script from "./ArticlesGenerateFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesGenerateFormPage.vue?vue&type=script&setup=true&lang=js"

import "./ArticlesGenerateFormPage.vue?vue&type=style&index=0&id=507c06a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-507c06a7"]])

export default __exports__